import { CoursesIcon, Select, SelectOptionType, Table, useDefaultSorting } from '@bp/ui-components';
import { FragmentType } from 'client/gql';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BpPermissionChecker } from 'utils/PermissionChecker';
import { UseCoursesFragment, useCourses } from '../hooks/useCourses';
import { CourseTableType } from '../types/types';
import { OrganizationConfigContext } from 'context/OrganizationConfigContext';
import { SingleValue } from 'react-select';

type CoursesStudentTableProps = {
  query: FragmentType<typeof UseCoursesFragment> | undefined;
  yearUuid: string;
  onYearSelect: (yearUuid: string) => void;
  onNavigate: (uuid: string) => void;
};

export const CoursesStudentTable = ({ query, yearUuid, onYearSelect, onNavigate }: CoursesStudentTableProps) => {
  const { t } = useTranslation();
  const { schoolyears } = useContext(OrganizationConfigContext);

  const { data, columns } = useCourses({
    query,
    showCourseInfo: true,
    columns: ['name', 'schoolYear'],
    onNavigate,
  });

  const { sorting, onSortingChange } = useDefaultSorting();

  const schoolYearOptions: SelectOptionType[] =
    schoolyears?.map(({ name, uuid }) => {
      return {
        label: name,
        value: uuid,
      };
    }) ?? [];

  return (
    <Table<CourseTableType>
      data={data}
      columns={columns}
      data-cy='courseList'
      canScroll
      showSort
      sorting={sorting}
      onSortingChange={onSortingChange}
      showActionBar
      actionBarSettings={{
        extendedActionsRight: (
          <div style={{ width: '136px' }}>
            <Select
              value={schoolYearOptions.find((y) => y.value === yearUuid)}
              options={schoolYearOptions}
              onChange={(option) => {
                onYearSelect((option as SingleValue<SelectOptionType>)?.value as string);
              }}
              name='school-year-select'
              dense
            />
          </div>
        ),
      }}
      isOnWhite={false}
      hideHeader={data.length === 0}
      showBorderRadius
      showShadow
      emptyStateSettings={{
        icon: <CoursesIcon className='svg-icon primary-light' />,
        padding: 'xl',
      }}
    />
  );
};
